import { Paragraph } from '@beamery/lib-ds-components';
import styled from 'styled-components';
export const StyledParagraph = styled(Paragraph) `
  margin-block-start: ${({ theme }) => theme.space.x2};
  margin-block-end: ${({ theme }) => theme.space.x2};
`;
